
export const MONTHS = {
    1: "Tháng 1",
    2: "Tháng 2",
    3: "Tháng 3",
    4: "Tháng 4",
    5: "Tháng 5",
    6: "Tháng 6",
    7: "Tháng 7",
    8: "Tháng 8",
    9: "Tháng 9",
    10: "Tháng 10",
    11: "Tháng 11",
    12: "Tháng 12",
};
export const YEARS = {
    2020: "2020",
    2021: "2021",
    2022: "2022",
    2023: "2023",
    2024: "2024",
    2025: "2025",
    2026: "2026",
    2027: "2027",
    2028: "2028",
    2029: "2029",
    2030: "2030",
};
export const STATUS_CROSS_ENUM = {
    1: {
        label: "Chờ tạo kết luận",
        class: "magenta"
    },
    2: {
        label: "Chờ đại lý/CTV/NVKD duyệt",
        class: "cyan"
    },
    3: {
        label: "Đại lý/CTV/NVKD từ chối",
        class: "purple"
    },
    4: {
        label: "Đại lý/CTV/NVKD đã duyệt",
        class: "geekblue"
    },
    5:{
        label: "FastCA đã duyệt",
        class: "orange"
    },
    6:{
        label: "Hoàn thành",
        class: "green"
    },
};
export const TYPE_USER_ENUM = {
    1: "Đại lý",
    2: "Cộng tác viên",
    3: "NVKD"
};